<template>
    <div class="tab-bar" :class="{ android: isAndroid }" v-if="!hideTabNavigation">
        <div class="fab-wrapper">
            <button class="fab-button" @click="() => router.push('/menu')">
                <span class="order-button">ORDER</span>
            </button>
        </div>

        <button class="tab-button" :class="{ active: isActiveRoute('/') }" @click="() => router.push('/')">
            <ion-icon :icon="isActiveRoute('/') ? home : homeOutline" class="nav-color"></ion-icon>
            <ion-label class="nav-color">HOME</ion-label>
        </button>

        <button class="tab-button" :class="{ active: isActiveRoute('/deals') }" @click="() => router.push('/deals')">
            <ion-icon :icon="isActiveRoute('/deals') ? pricetags : pricetagsOutline" class="nav-color"></ion-icon>
            <ion-label class="nav-color">DEALS</ion-label>
        </button>

        <!-- Tab Spacer  -->
        <svg></svg>

        <button class="tab-button" :class="{ active: isActiveRoute('/rewards') }" @click="() => router.push('/rewards')">
            <ion-icon :icon="isActiveRoute('/rewards') ? star : starOutline" class="nav-color"></ion-icon>
            <ion-label class="nav-color">REWARDS</ion-label>
        </button>

        <button class="tab-button" :class="{ active: isActiveRoute('/login') }" @click="() => (isLoggedIn ? router.push('/account') : router.push('/login'))">
            <ion-icon :icon="isActiveRoute('/login') ? person : personOutline" class="nav-color"></ion-icon>
            <ion-label class="nav-color">ACCOUNT</ion-label>
        </button>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { IonIcon, IonLabel } from '@ionic/vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { home, homeOutline, pricetags, pricetagsOutline, person, personOutline, star, starOutline } from 'ionicons/icons';

export default defineComponent({
    components: {
        IonLabel,
        IonIcon,
    },
    methods: {
        isActiveRoute(path: string): boolean {
            return this.router.currentRoute.value.path == path;
        },
    },
    setup() {
        const router = useRouter();
        const store = useStore();
        const isAndroid = computed(() => store.getters.isAndroid);
        const isLoggedIn = computed(() => store.getters.isLoggedIn);
        const hideTabNavigation = computed(() => router.currentRoute.value.meta?.hideTabNavigation);

        return {
            router,
            isAndroid,
            home,
            homeOutline,
            pricetags,
            pricetagsOutline,
            person,
            personOutline,
            star,
            starOutline,
            isLoggedIn,
            hideTabNavigation,
        };
    },
});
</script>

<style scoped>
.tab-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 90px;
    background: var(--ion-tab-bar-background, var(--ion-color-step-50, var(--ion-background-color, #fff)));
    border-top: 0.55px solid var(--ion-tab-bar-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.2))));
    padding-bottom: calc(env(safe-area-inset-bottom) + 4px);
    contain: none;
    z-index: 100;
}
.fab-wrapper {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -45px;
    display: flex;
    justify-content: center;
}
.fab-button {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    border: 7px solid var(--ion-color-light);
    background-color: var(--ion-color-primary);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}
.order-button {
    color: var(--ion-color-light);
    font-weight: bold;
    font-size: 1.2em;
}
.tab-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    gap: 4px;
    font-size: 12px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
}
button {
    width: 42px;
    height: 42px;
    background: none;
    font-size: 12px;
}
svg {
    width: 90px;
}
ion-icon {
    font-size: 2.25em;
}
.active ion-icon,
.active ion-label {
    color: var(--ion-color-primary);
}
.nav-color {
    color: #707070;
}
.tab-bar.android {
    height: 65px;
}
</style>
